import axios from 'axios';

export const FETCH_DRONESORGANISATION_BEGIN = 'FETCH_DRONESORGANISATION_BEGIN';
export const FETCH_DRONESORGANISATION_SUCCESS = 'FETCH_DRONESORGANISATION_SUCCESS';
export const FETCH_DRONESORGANISATION_FAILURE = 'FETCH_DRONESORGANISATION_FAILURE';

export const fetchDronesOrganisationBegin = () => ({
    type: FETCH_DRONESORGANISATION_BEGIN
});

export const fetchDronesOrganisationSuccess = DronesOrganisation => ({
    type: FETCH_DRONESORGANISATION_SUCCESS,
    payload: DronesOrganisation
});

export const fetchDronesOrganisationFailure = error => ({
    type: FETCH_DRONESORGANISATION_FAILURE,
    payload: { error }
});

export const getDronesOrganisation = (webappurl, accessToken, organisationId, droneTypes) => {

    return dispatch => {

        dispatch(fetchDronesOrganisationBegin());

        const data = {
            organisationId: organisationId,
            types: droneTypes
        };

        const options = {
            headers: {
                'Authorization': "Bearer " + accessToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return axios.post(webappurl + "/api/myCASA/forms/drone/GetDronesOrganisation/v1", data, options)
            .then(responseArr => {
                return dispatch(fetchDronesOrganisationSuccess(responseArr.data.value));
            })
            .catch(error => {
                return dispatch(fetchDronesOrganisationFailure("System error DO.1: " + error));
            });
    };
}